import { IClienteContrato } from '../../interfaces/cliente-contrato.interface';

/** Calcula dias para vencer a partir da data de validade */
export function getContratoDiasParaVencer(entity: IClienteContrato): number {
  if (!entity.dataValidadeContrato) {
    return null;
  }
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const validade = new Date(entity.dataValidadeContrato);
  validade.setHours(0, 0, 0, 0);
  return Math.ceil((validade.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
}

/** Verifica se o contrato está vencido */
export function isContratoVencido(entity: IClienteContrato): boolean {
  const dias = getContratoDiasParaVencer(entity);
  return dias != null && dias < 0;
}

/** Retorna o texto descritivo do status do contrato a partir dos campos da entity */
export function getContratoStatusText(entity: IClienteContrato): string {
  const dias = entity.contratoDiasParaVencer;
  if (dias == null) {
    return 'Sem prazo definido';
  }
  if (dias < 0) {
    return `Vencido há ${Math.abs(dias)} dias`;
  }
  if (dias === 0) {
    return 'Vence hoje';
  }
  return `Vence em ${dias} dias`;
}

/** Retorna a classe CSS do badge de status a partir dos campos da entity */
export function getContratoStatusBadgeClass(entity: IClienteContrato): string {
  if (entity.contratoVencido) {
    return 'badge-danger';
  }
  const dias = entity.contratoDiasParaVencer;
  if (dias != null && dias <= 30) {
    return 'badge-warning';
  }
  return 'badge-success';
}
